export enum EventLogType {
    ADD_EVENT = 'add_event',
    CREATE_DATALAYER = 'create_datalayer',
    RESET_DATALAYER = 'reset_datalayer',
}
